export const categories = [
  {
    id: "beer",
    name: "Beer",
    image: "/assets/images/categories/beer.png",
    active: true,
  },
  {
    id: "wine",
    name: "Wine",
    image: "/assets/images/categories/wine.png",
    active: true,
  },
  {
    id: "spirits",
    name: "Spirits",
    image: "/assets/images/categories/spirits.png",
    active: true,
  },
  {
    id: "rtd",
    name: "RTD",
    image: "/assets/images/categories/rtd.png",
    active: true,
  },
  {
    id: "extra",
    name: "Extras",
    image: "/assets/images/categories/extra.png",
    active: false,
  },
];

export const beerBrands = [
  {
    id: "heineken",
    name: "Heineken",
    image: "/assets/images/beer/brands/Heineken330ml.png",
  },
  {
    id: "stella",
    name: "Stella",
    image: "/assets/images/beer/brands/StellaBottle500ml.png",
  },
  {
    id: "sakara",
    name: "Sakara",
    image: "/assets/images/beer/brands/SakaraGold500ml.png",
  },
  {
    id: "meister",
    name: "Meister",
    image: "/assets/images/beer/brands/MeisterMaxBottle500ml.png",
  },
  {
    id: "desperados",
    name: "Desperados",
    image: "/assets/images/beer/brands/Desperados.png",
  },
  {
    id: "sol",
    name: "SOL",
    image: "/assets/images/beer/brands/Sol.png",
  },
];

export const wineSubcategories = [
  {
    id: "red-wine",
    name: "Red Wine",
    image: "/assets/images/wine/subcategories/redwine_7.png",
  },
  {
    id: "rose-wine",
    name: "Rosé Wine",
    image: "/assets/images/wine/subcategories/rosewine_3.png",
  },
  {
    id: "white-wine",
    name: "White Wine",
    image: "/assets/images/wine/subcategories/whitewine_8.png",
  },
  {
    id: "sweet-wine",
    name: "Sweet Wine",
    image: "/assets/images/wine/subcategories/sweetwine_2.png",
  },
  {
    id: "sparkling-wine",
    name: "Sparkling Wine",
    image: "/assets/images/wine/subcategories/sparkingwine_5.png",
  },
];

export const spiritsSubcategories = [
  {
    id: "whiskey",
    name: "Whiskey",
    image: "/assets/images/spirits/subcategories/whisky_1.png",
  },
  {
    id: "rum",
    name: "Rum",
    image: "/assets/images/spirits/subcategories/rum-1.png",
  },
  {
    id: "vodka",
    name: "Vodka",
    image: "/assets/images/spirits/subcategories/vodka-1.png",
  },
  {
    id: "gin",
    name: "Gin",
    image: "/assets/images/spirits/subcategories/gin-1.png",
  },
  {
    id: "brandy",
    name: "Brandy",
    image: "/assets/images/spirits/subcategories/brandy-1.png",
  },
  {
    id: "arak",
    name: "Arak",
    image: "/assets/images/spirits/subcategories/arak-1.png",
  },
  {
    id: "tequila",
    name: "Tequila",
    image: "/assets/images/spirits/subcategories/tequila-1.png",
  },
  {
    id: "ouzo",
    name: "Ouzo",
    image: "/assets/images/spirits/products/ouzo.png",
  },
  {
    id: "liqueur",
    name: "Liqueur",
    image: "/assets/images/spirits/products/liqueur.png",
  },
];

export const rtdSubcategories = [
  {
    id: "id",
    name: "ID",
    image: "/assets/images/rtd/subcategories/id-1.png",
  },
  {
    id: "blue40-freeze",
    name: "Blue40 Freeze",
    image: "/assets/images/rtd/subcategories/blue40-freeze-1.png",
  },
  {
    id: "butlers",
    name: "Butler's",
    image: "/assets/images/rtd/subcategories/butlers-1.png",
  },
  {
    id: "others",
    name: "Others",
    image: "/assets/images/rtd/products/other1.png",
  },
];

export const subcategoriesByCategory = {
  beer: beerBrands,
  wine: wineSubcategories,
  spirits: spiritsSubcategories,
  rtd: rtdSubcategories,
};

export const productsData = {
  heineken: [
    {
      id: "heineken-1",
      name: "Heineken Can 500ml",
      brand: "heineken",
      alcohol: "5.0% Alcohol",
      price: 70,
      image: "/assets/images/beer/products/Heineken500ml.png",
    },
    {
      id: "heineken-2",
      name: "Heineken Can 330ml",
      brand: "heineken",
      alcohol: "5.0% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/Heineken330can.png",
    },
    {
      id: "heineken-3",
      name: "Heineken Bottle 330ml",
      brand: "heineken",
      alcohol: "5.0% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/Heineken330ml.png",
    },
  ],
  stella: [
    {
      id: "stella-1",
      name: "Stella Bottle 500ml",
      brand: "stella",
      alcohol: "4.5% Alcohol",
      price: 60,
      image: "/assets/images/beer/products/StellaBottle500ml.png",
    },
    {
      id: "stella-2",
      name: "Stella Bottle 330ml",
      brand: "stella",
      alcohol: "4.5% Alcohol",
      price: 50,
      image: "/assets/images/beer/products/StellaBottle330ml.png",
    },
    {
      id: "stella-3",
      name: "Stella Can 500ml",
      brand: "stella",
      alcohol: "4.5% Alcohol",
      price: 60,
      image: "/assets/images/beer/products/StellaCan500ml.png",
    },
    {
      id: "stella-4",
      name: "Stella Can 330ml",
      brand: "stella",
      alcohol: "4.5% Alcohol",
      price: 50,
      image: "/assets/images/beer/products/StellaCan330ml.png",
    },
    {
      id: "stella-5",
      name: "Stella Ice Can 500ml",
      brand: "stella",
      alcohol: "8.0% Alcohol",
      price: 65,
      image: "/assets/images/beer/products/StellaIce.png",
    },
    {
      id: "stella-6",
      name: "Stella Returnable Bottle 500ml",
      brand: "stella",
      alcohol: "8.0% Alcohol",
      price: 60,
      image: "/assets/images/beer/products/stelaRet.png",
    },
  ],
  sakara: [
    {
      id: "sakara-1",
      name: "Sakara El-King 15 Can 500ml",
      brand: "sakara",
      alcohol: "15.0% Alcohol",
      price: 85,
      image: "/assets/images/beer/products/SakaraCan500ml.png",
    },
    {
      id: "sakara-2",
      name: "Sakara El-King 15 Bottle 500ml",
      brand: "sakara",
      alcohol: "15.0% Alcohol",
      price: 85,
      image: "/assets/images/beer/products/SakaraBottle500ml.png",
    },
    {
      id: "sakara-3",
      name: "Sakara El-King 10 Can 500ml",
      brand: "sakara",
      alcohol: "10.0% Alcohol",
      price: 75,
      image: "/assets/images/beer/products/ElKing.png",
    },
    {
      id: "sakara-4",
      name: "Sakara El-King 10 Bottle 500ml",
      brand: "sakara",
      alcohol: "10.0% Alcohol",
      price: 75,
      image: "/assets/images/beer/products/El-King10Bottle500ml.png",
    },
    {
      id: "sakara-5",
      name: "Sakara Gold Bottle 500ml",
      brand: "sakara",
      alcohol: "4.0% Alcohol",
      price: 65,
      image: "/assets/images/beer/products/SakaraGold500ml.png",
    },
  ],
  meister: [
    {
      id: "meister-1",
      name: "Meister Max Can 500ml",
      brand: "meister",
      alcohol: "8.0% Alcohol",
      price: 65,
      image: "/assets/images/beer/products/MeisterMaxCan500ml.png",
    },
    {
      id: "meister-2",
      name: "Meister Max Bottle 500ml",
      brand: "meister",
      alcohol: "8.0% Alcohol",
      price: 65,
      image: "/assets/images/beer/products/MeisterMaxBottle500ml.png",
    },
    {
      id: "meister-3",
      name: "Meister Max Bottle 330ml",
      brand: "meister",
      alcohol: "8.0% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/MeisterMaxBottle330ml.png",
    },
  ],
  desperados: [
    {
      id: "desperados-1",
      name: "Desperados Lemon 330ml",
      brand: "desperados",
      alcohol: "5.9% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/Desperados.png",
    },
    {
      id: "desperados-2",
      name: "Desperados Original 330ml",
      brand: "desperados",
      alcohol: "5.9% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/DesperadosOriginal.png",
    },
    {
      id: "desperados-3",
      name: "Desperados Red 330ml",
      brand: "desperados",
      alcohol: "5.9% Alcohol",
      price: 58,
      image: "/assets/images/beer/products/DesperadosRed.png",
    },
  ],
  sol: [
    {
      id: "sol-1",
      name: "SOL Bottle 330ml",
      brand: "sol",
      alcohol: "4.2% Alcohol",
      price: 55,
      image: "/assets/images/beer/products/Sol.png",
    },
    {
      id: "sol-2",
      name: "SOL Bottle 500ml",
      brand: "sol",
      alcohol: "4.2% Alcohol",
      price: 65,
      image: "/assets/images/beer/products/SolBottle500.png",
    },
  ],
  "red-wine": [
    {
      id: "red-wine-1",
      name: "Chateau de Grandville Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 550,
      image: "/assets/images/wine/products/redwine_1.png",
    },
    {
      id: "red-wine-2",
      name: "Cape Bay Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 450,
      image: "/assets/images/wine/products/redwine_2.png",
    },
    {
      id: "red-wine-3",
      name: "Grand Marquis Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.0% Alcohol",
      price: 340,
      image: "/assets/images/wine/products/redwine_3.png",
    },
    {
      id: "red-wine-4",
      name: "Castello Di Trevi Red Wine 750ml",
      brand: "red-wine",
      alcohol: "13.0% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/redwine_4.png",
    },
    {
      id: "red-wine-5",
      name: "365 Red 750ml",
      brand: "red-wine",
      alcohol: "13.0% Alcohol",
      price: 280,
      image: "/assets/images/wine/products/365redwine.png",
    },
    {
      id: "red-wine-6",
      name: "Baila Red Wine 750ml Discovery Vineyards Range",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 525,
      image: "/assets/images/wine/products/redwine_6.png",
    },
    {
      id: "red-wine-7",
      name: "Chateau Byblos Red Wine 750ml Discovery Vineyards Range",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 475,
      image: "/assets/images/wine/products/redwine_7.png",
    },
    {
      id: "red-wine-8",
      name: "Beausoleil Red Wine Cabernet Sauvignon 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 375,
      image: "/assets/images/wine/products/redwine_8.png",
    },
    {
      id: "red-wine-9",
      name: "Jardin du Nil Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/redwine_9.png",
    },
    {
      id: "red-wine-10",
      name: "Nala Red Wine 750ml Discovery Vineyards Range",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 575,
      image: "/assets/images/wine/products/redwine_10.png",
    },
    {
      id: "red-wine-11",
      name: "Omar Khayyam Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 260,
      image: "/assets/images/wine/products/redwine_11.png",
    },
    {
      id: "red-wine-12",
      name: "Shahrazade Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 240,
      image: "/assets/images/wine/products/redwine_12.png",
    },
    {
      id: "red-wine-13",
      name: "Beausoleil Red Wine Syrah 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 380,
      image: "/assets/images/wine/products/redwine_13.png",
    },
    {
      id: "red-wine-14",
      name: "XO Red Wine 750ml",
      brand: "red-wine",
      alcohol: "12.5% Alcohol",
      price: 290,
      image: "/assets/images/wine/products/redwine_14.png",
    },
  ],
  "rose-wine": [
    {
      id: "rose-wine-1",
      name: "365 Rose 750ml",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 280,
      image: "/assets/images/wine/products/365rosewine.png",
    },
    {
      id: "rose-wine-2",
      name: "Baila Rose Wine 750ml Discovery Vineyards Range",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 525,
      image: "/assets/images/wine/products/rosewine_2.png",
    },
    {
      id: "rose-wine-3",
      name: "Beausoleil Rose Magnum – Limited Edition 1.5L",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 700,
      image: "/assets/images/wine/products/rosewine_3.png",
    },
    {
      id: "rose-wine-4",
      name: "Beausoleil Rose Wine 750ml",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 375,
      image: "/assets/images/wine/products/rosewine_4.png",
    },
    {
      id: "rose-wine-5",
      name: "Omar Khayyam Rose Wine 750ml",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 260,
      image: "/assets/images/wine/products/rosewine_5.png",
    },
    {
      id: "rose-wine-6",
      name: "Shahrazade Rose Wine 750ml",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 240,
      image: "/assets/images/wine/products/rosewine_6.png",
    },
    {
      id: "rose-wine-7",
      name: "XO Rose Wine 750ml",
      brand: "rose-wine",
      alcohol: "12.5% Alcohol",
      price: 290,
      image: "/assets/images/wine/products/rosewine_7.png",
    },
  ],
  "white-wine": [
    {
      id: "white-wine-1",
      name: "Chateau de Grandville White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.0% Alcohol",
      price: 550,
      image: "/assets/images/wine/products/whitewine_1.png",
    },
    {
      id: "white-wine-2",
      name: "Cape Bay White Wine Chardonnay SE 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 450,
      image: "/assets/images/wine/products/whitewine_2.png",
    },
    {
      id: "white-wine-3",
      name: "Grand Marquis White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 340,
      image: "/assets/images/wine/products/whitewine_3.png",
    },
    {
      id: "white-wine-4",
      name: "Castello Di Trevi White Wine 750ml",
      brand: "white-wine",
      alcohol: "13.5% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/whitewine_4.png",
    },
    {
      id: "white-wine-5",
      name: "365 White 750ml",
      brand: "white-wine",
      alcohol: "11.5% Alcohol",
      price: 280,
      image: "/assets/images/wine/products/365whitewine.png",
    },
    {
      id: "white-wine-6",
      name: "Baila White Wine 750ml Discovery Vineyards Range",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 525,
      image: "/assets/images/wine/products/whitewine_6.png",
    },
    {
      id: "white-wine-7",
      name: "Beausoleil White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 375,
      image: "/assets/images/wine/products/whitewine_7.png",
    },
    {
      id: "white-wine-8",
      name: "Chateau Byblos White Wine 750ml Discovery Vineyards Range",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 450,
      image: "/assets/images/wine/products/whitewine_8.png",
    },
    {
      id: "white-wine-9",
      name: "Cape Bay White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 430,
      image: "/assets/images/wine/products/whitewine_9.png",
    },
    {
      id: "white-wine-10",
      name: "Jardin du Nil White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/whitewine_10.png",
    },
    {
      id: "white-wine-11",
      name: "Nala White Wine 750ml Discovery Vineyards Range",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 550,
      image: "/assets/images/wine/products/whitewine_11.png",
    },
    {
      id: "white-wine-12",
      name: "Omar Khayyam White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 260,
      image: "/assets/images/wine/products/whitewine_12.png",
    },
    {
      id: "white-wine-13",
      name: "Shahrazade White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 240,
      image: "/assets/images/wine/products/whitewine_13.png",
    },
    {
      id: "white-wine-14",
      name: "XO White Wine 750ml",
      brand: "white-wine",
      alcohol: "12.5% Alcohol",
      price: 290,
      image: "/assets/images/wine/products/whitewine_14.png",
    },
  ],
  "sweet-wine": [
    {
      id: "sweet-wine-1",
      name: "Shahrazade Abarka Sweet Red Wine 750ml",
      brand: "sweet-wine",
      alcohol: "14.5% Alcohol",
      price: 230,
      image: "/assets/images/wine/products/sweetwine_1.png",
    },
    {
      id: "sweet-wine-2",
      name: "Beausoleil Port Style Wine 750ml",
      brand: "sweet-wine",
      alcohol: "15% Alcohol",
      price: 375,
      image: "/assets/images/wine/products/sweetwine_2.png",
    },
    {
      id: "sweet-wine-3",
      name: "Abarka Wine 750ml",
      brand: "sweet-wine",
      alcohol: "16% Alcohol",
      price: 240,
      image: "/assets/images/wine/products/sweetwine_3.png",
    },
    {
      id: "sweet-wine-4",
      name: "Grand Marquis Sweet Red 750ml",
      brand: "sweet-wine",
      alcohol: "16% Alcohol",
      price: 340,
      image: "/assets/images/wine/products/gmsweetwine.png",
    },
  ],
  "sparkling-wine": [
    {
      id: "sparkling-wine-1",
      name: "Aria Rose Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 455,
      image: "/assets/images/wine/products/sparkingwine_1.png",
    },
    {
      id: "sparkling-wine-2",
      name: "Aria White Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 450,
      image: "/assets/images/wine/products/sparkingwine_2.png",
    },
    {
      id: "sparkling-wine-3",
      name: "Lavita White Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 385,
      image: "/assets/images/wine/products/sparkingwine_3.png",
    },
    {
      id: "sparkling-wine-4",
      name: "Lavita Rose Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 390,
      image: "/assets/images/wine/products/sparkingwine_4.png",
    },
    {
      id: "sparkling-wine-5",
      name: "Le Baron White Signature Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 855,
      image: "/assets/images/wine/products/sparkingwine_5.png",
    },
    {
      id: "sparkling-wine-6",
      name: "Le Baron Rose Signature Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 750,
      image: "/assets/images/wine/products/sparkingwine_6.png",
    },
    {
      id: "sparkling-wine-7",
      name: "Le Baron White Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 755,
      image: "/assets/images/wine/products/sparkingwine_7.png",
    },
    {
      id: "sparkling-wine-8",
      name: "Valmont Rose Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/sparkingwine_8.png",
    },
    {
      id: "sparkling-wine-9",
      name: "Valmont White Sparkling Wine 750ml",
      brand: "sparkling-wine",
      alcohol: "12.5% Alcohol",
      price: 400,
      image: "/assets/images/wine/products/sparkingwine_9.png",
    },
  ],
  whiskey: [
    {
      id: "whiskey-1",
      name: "Devlin Whiskey 750ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 850,
      image: "/assets/images/spirits/products/whisky_1.png",
    },
    {
      id: "whiskey-2",
      name: "Devlin Blended Whiskey 750ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 550,
      image: "/assets/images/spirits/products/whisky_2.png",
    },
    {
      id: "whiskey-3",
      name: "Auld Stag 750ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/whisky_3.png",
    },
    {
      id: "whiskey-4",
      name: "BOLANACHI Hydelands 750ml",
      brand: "whiskey",
      alcohol: "35% Alcohol",
      price: 155,
      image: "/assets/images/spirits/products/whisky_4.png",
    },
    {
      id: "whiskey-5",
      name: "Auld Stag 350ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 130,
      image: "/assets/images/spirits/products/whisky_5.png",
    },
    {
      id: "whiskey-6",
      name: "Yanni Whisky 1L",
      brand: "whiskey",
      alcohol: "35% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/whiskinew1.png",
    },
    {
      id: "whiskey-7",
      name: "Mosaic Whisky The Bartender Edition 750ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 220,
      image: "/assets/images/spirits/products/whiskinew2.png",
    },
    {
      id: "whiskey-8",
      name: "Black Rhino Whisky 750ml",
      brand: "whiskey",
      alcohol: "40% Alcohol",
      price: 495,
      image: "/assets/images/spirits/products/whiskinew3.png",
    },
  ],
  rum: [
    {
      id: "rum-1",
      name: "Cubana Rum 750ml",
      brand: "rum",
      alcohol: "40% Alcohol",
      price: 380,
      image: "/assets/images/spirits/products/rum-1.png",
    },
    {
      id: "rum-2",
      name: "BOLANACHI Rum Aloha 750ml",
      brand: "rum",
      alcohol: "35% Alcohol",
      price: 155,
      image: "/assets/images/spirits/products/rum-2.png",
    },
    {
      id: "rum-3",
      name: "Yanni Rum 1L",
      brand: "rum",
      alcohol: "30% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/rumnew1.png",
    },
    {
      id: "rum-4",
      name: "Mosaic Rum Gold The Bartender Edition 750ml",
      brand: "rum",
      alcohol: "35% Alcohol",
      price: 220,
      image: "/assets/images/spirits/products/rumnew2.png",
    },
    {
      id: "rum-5",
      name: "Mosaic Rum White The Bartender Edition 750ml",
      brand: "rum",
      alcohol: "35% Alcohol",
      price: 220,
      image: "/assets/images/spirits/products/rumnew3.png",
    },
  ],
  vodka: [
    {
      id: "vodka-1",
      name: "ID Vodka Blue40 750ml",
      brand: "vodka",
      alcohol: "40% Alcohol",
      price: 440,
      image: "/assets/images/spirits/products/vodka-1.png",
    },
    {
      id: "vodka-2",
      name: "Blue40 Raspberry",
      brand: "vodka",
      alcohol: "38% Alcohol",
      price: 440,
      image: "/assets/images/spirits/products/vodka-2.png",
    },
    {
      id: "vodka-3",
      name: "Blue40 Citrus",
      brand: "vodka",
      alcohol: "38% Alcohol",
      price: 440,
      image: "/assets/images/spirits/products/vodka-3.png",
    },
    {
      id: "vodka-4",
      name: "ID Vodka 750ml",
      brand: "vodka",
      alcohol: "38% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/vodka-4.png",
    },
    {
      id: "vodka-5",
      name: "BOLANACHI Vodka Volga 750ml",
      brand: "vodka",
      alcohol: "35% Alcohol",
      price: 155,
      image: "/assets/images/spirits/products/vodka-5.png",
    },
    {
      id: "vodka-6",
      name: "ID Vodka 350ml",
      brand: "vodka",
      alcohol: "38% Alcohol",
      price: 140,
      image: "/assets/images/spirits/products/vodka-6.png",
    },
    {
      id: "vodka-7",
      name: "Yanni Vodka 1L",
      brand: "vodka",
      alcohol: "35% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/vodkanew1.png",
    },
    {
      id: "vodka-8",
      name: "Mosaic Vodka The Bartender Edition 750ml",
      brand: "vodka",
      alcohol: "38% Alcohol",
      price: 220,
      image: "/assets/images/spirits/products/vodkanew2.png",
    },
    {
      id: "vodka-9",
      name: "Swan Premium Vodka 750ml",
      brand: "vodka",
      alcohol: "40% Alcohol",
      price: 400,
      image: "/assets/images/spirits/products/vodkanew3.png",
    },
  ],
  gin: [
    {
      id: "gin-1",
      name: "Butler's 750ml",
      brand: "gin",
      alcohol: "40% Alcohol",
      price: 525,
      image: "/assets/images/spirits/products/gin-1.png",
    },
    {
      id: "gin-2",
      name: "ID Gin 750ml",
      brand: "gin",
      alcohol: "38% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/gin-2.png",
    },
    {
      id: "gin-3",
      name: "BOLANACHI Gin Oxford 750ml",
      brand: "gin",
      alcohol: "35% Alcohol",
      price: 140,
      image: "/assets/images/spirits/products/gin-3.png",
    },
    {
      id: "gin-4",
      name: "Yanni Gin 1L",
      brand: "gin",
      alcohol: "35% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/ginnew1.png",
    },
    {
      id: "gin-5",
      name: "Mosaic Gin The Bartender Edition 750ml",
      brand: "gin",
      alcohol: "35% Alcohol",
      price: 220,
      image: "/assets/images/spirits/products/ginnew2.png",
    },
    {
      id: "gin-6",
      name: "Harry’s Premium Gin 750ml",
      brand: "gin",
      alcohol: "40% Alcohol",
      price: 500,
      image: "/assets/images/spirits/products/ginnew3.png",
    },
  ],
  brandy: [
    {
      id: "brandy-1",
      name: "Dinsmore Brandy 750ml",
      brand: "brandy",
      alcohol: "38% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/brandy-1.png",
    },
    {
      id: "brandy-2",
      name: "BOLANACHI Brandy Normandy 750ml",
      brand: "brandy",
      alcohol: "30% Alcohol",
      price: 155,
      image: "/assets/images/spirits/products/brandy-2.png",
    },
    {
      id: "brandy-3",
      name: "Mosaic Cognac Style 750ml",
      brand: "brandy",
      alcohol: "40% Alcohol",
      price: 375,
      image: "/assets/images/spirits/products/brandynew1.png",
    },
    {
      id: "brandy-4",
      name: "Yanni Brandy 1L",
      brand: "brandy",
      alcohol: "30% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/brandynew2.png",
    },
  ],
  arak: [
    {
      id: "arak-1",
      name: "Miraki 750ml",
      brand: "arak",
      alcohol: "42% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/arak-1.png",
    },
    {
      id: "arak-2",
      name: "Arak Kesrouan 500ml",
      brand: "arak",
      alcohol: "50% Alcohol",
      price: 300,
      image: "/assets/images/spirits/products/arak2.png",
    },
  ],
  tequila: [
    {
      id: "tequila-1",
      name: "Malvado 750ml",
      brand: "tequila",
      alcohol: "38% Alcohol",
      price: 250,
      image: "/assets/images/spirits/products/tequila-1.png",
    },
    {
      id: "tequila-2",
      name: "BOLANACHI Sombrero 750ml",
      brand: "tequila",
      alcohol: "35% Alcohol",
      price: 155,
      image: "/assets/images/spirits/products/tequla-2.png",
    },
    {
      id: "tequila-3",
      name: "Yanni Tequila 1L",
      brand: "tequila",
      alcohol: "35% Alcohol",
      price: 185,
      image: "/assets/images/spirits/products/teqilanew2.png",
    },
  ],
  ouzo: [
    {
      id: "ouzo-1",
      name: "Yanni Ouzo 1L",
      brand: "ouzo",
      alcohol: "40% Alcohol",
      price: 216,
      image: "/assets/images/spirits/products/ouzo.png",
    },
  ],
  liqueur: [
    {
      id: "liqueur-1",
      name: "Skinos Mastiha Spirit",
      brand: "liqueur",
      alcohol: "30% Alcohol",
      price: 1750,
      image: "/assets/images/spirits/products/liqueur.png",
    },
  ],
  id: [
    {
      id: "id-1",
      name: "ID XXXX Watermelon 275ml",
      brand: "id",
      alcohol: "20% Alcohol",
      price: 80,
      image: "/assets/images/rtd/products/id-1.png",
    },
    {
      id: "id-2",
      name: "ID XXXX Pineapple & Coconut 275ml",
      brand: "id",
      alcohol: "20% Alcohol",
      price: 75,
      image: "/assets/images/rtd/products/id-2.png",
    },
    {
      id: "id-3",
      name: "ID XXXX Mango 275ml",
      brand: "id",
      alcohol: "20% Alcohol",
      price: 80,
      image: "/assets/images/rtd/products/id-3.png",
    },
    {
      id: "id-4",
      name: "ID XXX Cherry 275ml",
      brand: "id",
      alcohol: "15% Alcohol",
      price: 70,
      image: "/assets/images/rtd/products/id-4.png",
    },
    {
      id: "id-5",
      name: "ID XXX 15% Watermelon 275ml",
      brand: "id",
      alcohol: "15% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/id-5.png",
    },
    {
      id: "id-6",
      name: "ID Double Edge Watermelon 275ml",
      brand: "id",
      alcohol: "10% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/id-6.png",
    },
    {
      id: "id-7",
      name: "ID Double Edge Energy 275ml",
      brand: "id",
      alcohol: "10% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/id-7.png",
    },
    {
      id: "id-8",
      name: "ID Double Edge Peach",
      brand: "id",
      alcohol: "10% Alcohol",
      price: 60,
      image: "/assets/images/rtd/products/id-8.png",
    },
  ],
  "blue40-freeze": [
    {
      id: "blue40-freeze-1",
      name: "Blue40 Freeze Sky Colada",
      brand: "blue40-freeze",
      alcohol: "6.5% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/blue40-freeze-1.png",
    },
    {
      id: "blue40-freeze-2",
      name: "Blue40 Freeze Pink Berry",
      brand: "blue40-freeze",
      alcohol: "8% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/blue40-freeze-2.png",
    },
    {
      id: "blue40-freeze-3",
      name: "Blue40 Freeze Original",
      brand: "blue40-freeze",
      alcohol: "8% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/blue40-freeze-3.png",
    },
  ],
  butlers: [
    {
      id: "butlers-1",
      name: "Butler's XXX Gin Lemon Mint 275ml",
      brand: "butlers",
      alcohol: "20% Alcohol",
      price: 80,
      image: "/assets/images/rtd/products/butlers-1.png",
    },
    {
      id: "butlers-2",
      name: "Butler's XXX Gin Lime 275ml",
      brand: "butlers",
      alcohol: "15% Alcohol",
      price: 70,
      image: "/assets/images/rtd/products/butlers-2.png",
    },
    {
      id: "butlers-3",
      name: "BUTLERS Apple Cin 10%",
      brand: "butlers",
      alcohol: "10% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/butlers-3.png",
    },
    {
      id: "butlers-4",
      name: "Butler's Gin Lemon Mint 275ml",
      brand: "butlers",
      alcohol: "10% Alcohol",
      price: 65,
      image: "/assets/images/rtd/products/butlers-4.png",
    },
  ],
  others: [
    {
      id: "others-1",
      name: "XO Sangria White 10% 275ml",
      brand: "others",
      alcohol: "10% Alcohol",
      price: 75,
      image: "/assets/images/rtd/products/other1.png",
    },
    {
      id: "others-2",
      name: "21+ Pina Colada 10% 275ml",
      brand: "others",
      alcohol: "10% Alcohol",
      price: 60,
      image: "/assets/images/rtd/products/other2.png",
    },
    {
      id: "others-3",
      name: "XO Sangria Red 10% 275ml",
      brand: "others",
      alcohol: "10% Alcohol",
      price: 75,
      image: "/assets/images/rtd/products/other3.png",
    },
  ],
};
